import useSWR from 'swr';
import { useContext, useState } from 'react';
import { AppContext } from 'providers/AppProvider';
import { RiskQResults } from 'types';

export type RiskqResultsProps = Readonly<ReturnType<typeof useRiskqResults>>;

export function useRiskqResults() {
	const ctx = useContext(AppContext);
	const { config, http, state, fetchRelations, t } = ctx;
	const { API } = config;
	const ssn = state.context.kennitala;
	const { data } = useSWR<RiskQResults>(`${API.riskqResults}/${ssn}`);
	const [isConfirmed, setIsConfirmed] = useState(false);
	const [selectedRiskProfileId, setSelectedRiskProfileId] = useState(-1);
	const processId = state.context?.processInfo?.agreementProcessId;
	const submitDisabled = !processId || !isConfirmed || -1 === selectedRiskProfileId;

	const handleSubmit = async (e: any) => {
		e.preventDefault();
		if (!submitDisabled) {
			const payload = { selectedRiskProfileId, ssn };
			const msg = t('submit_label', 'riskq_results');
			http
				.post(`${API.riskq}/${processId}/suitabilityRiskProfiles/updateSelectedRiskProfile`, payload, msg)
				.then(() => fetchRelations(true));
		}
	};

	return {
		...ctx,
		data,
		handleSubmit,
		isConfirmed,
		selectedRiskProfileId,
		setIsConfirmed,
		setSelectedRiskProfileId,
		submitDisabled
	};
}
